import React, { useContext, useRef, useState, useEffect } from "react";

import { CoursesContext } from "context/coursesContext";
import { MeetingsContext } from "context/meetingsContext";
import { teacherLinks } from "./teacherLinks";

import { SnackBarActions } from "components/SnackBarActions";
import { ModalPremium } from "components/ModalPremium";
import { ConfirmationModal } from "components/Speaking-components/confirmation-modal";
import TeachersList from "components/Speaking-components/teacher-list";
import TopicsList from "components/Speaking-components/topics-list";
import { Calendar } from "components/Speaking-components/calendar";
import { UpgradePlanPage } from "components/UpgradePlanPage";
import "../../styles/Calendar.css";

const initialSnackBar = {
  isSnackBarOpen: false,
  severity: "success",
  message: "",
};

const SpeakingPage = ({ requiredPlanFeature }) => {
  const { courses, userPlan } = useContext(CoursesContext);
  const { sectionPlanSpeaking, getSectionPlanUser } =
    useContext(MeetingsContext);

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isSchedulingModuleOpen, setIsSchedulingModuleOpen] = useState(false);
  const [topicToSchedule, setTopicToSchedule] = useState(null);
  const [teachersArray, setTeachersArray] = useState(null);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [hasRequiredPlan, setHasRequiredPlan] = useState(false);

  const [snackBarInfo, setSnackBarInfo] = useState(initialSnackBar);

  const goToTop = () => {
    Page.current.scrollIntoView();
  };

  const Page = useRef(null);

  const handleConfirmScheduling = async (confirmed) => {
    if (confirmed) {
      let tempTeachersArray = [];
      let [obj] = teacherLinks.filter(
        (obj) => obj.id === topicToSchedule.courseID
      );

      obj.teachers.forEach((teacher) => {
        let [topic] = teacher.topics.filter(
          (topic) => topic.id === topicToSchedule.topic.position
        );

        if (!!topic) {
          let teacherObj = { name: teacher.name, link: topic.link };
          tempTeachersArray.push(teacherObj);
        }
      });

      setTeachersArray(tempTeachersArray);
      setIsSchedulingModuleOpen(true);
      goToTop();
    }

    setIsConfirmationModalOpen(false);
  };

  const openConfirmation = (courseID, topic) => {
    setTopicToSchedule({ courseID, topic });
    setIsConfirmationModalOpen(true);
  };

  const closeSnackBar = () => {
    setSnackBarInfo({
      ...snackBarInfo,
      isSnackBarOpen: false,
    });
  };

  useEffect(() => {
    setHasRequiredPlan(
      userPlan?.features?.find(
        (item) => item.featureName === requiredPlanFeature && item.enabled
      )
    );
  }, [userPlan]);

  useEffect(() => {
    if (!isSchedulingModuleOpen) {
      window.scrollTo(0, 0);
    }
  }, [isSchedulingModuleOpen]);

  return hasRequiredPlan ? (
    <div className="pt-8 pb-14 p-5 bg-[#1B212B]" ref={Page}>
      <div className="flex flex-col lg:flex-row justify-evenly py-6 px-4 bg-[#1B212B] text-[20px]">
        <div className="flex lg:shrink-0 content-center justify-center">
          {(isSchedulingModuleOpen || selectedTeacher) && (
            <button
              onClick={() => {
                selectedTeacher
                  ? setSelectedTeacher(null)
                  : setIsSchedulingModuleOpen(false);
                getSectionPlanUser(); //Se actualiza el plan por si lo modifico

              }}
              className="px-8 rounded-full bg-[#CF7831] hover:opacity-75  text-white font-semibold w-fit hidden lg:block max-h-10"
            >
              {selectedTeacher
                ? "← Back to all coaches"
                : "← Back to topics list"}
            </button>
          )}
        </div>

        <div className="flex flex-col text-center flex-grow lg:pr-56">
          <h1 className="main-title text-[#7DB8F2] text-[1.2em] font-[700]">
            Schedule your speaking sessions
          </h1>
          <p className="text-md py-2 text-[#7DB8F2]">
            Practical sessions available this month:{" "}
            <strong>{sectionPlanSpeaking.appointmentsLeft}</strong>
          </p>
        </div>
      </div>
      <ModalPremium isModalOpen={false} />

      <div
        className="calendar-container pt-8 pb-14 p-5 bg-[#1B212B]"
        ref={Page}
      >
        {isSchedulingModuleOpen ? (
          selectedTeacher ? (
            <Calendar
              selectedTeacher={selectedTeacher}
              closeCalendar={() => {
                getSectionPlanUser(); //Se actualiza el plan por si lo modifico
                setSelectedTeacher(null);
              }}
              goBackToTopics={() => {
                setIsSchedulingModuleOpen(false);
              }}
              showSnackBar={(data) => {
                setSnackBarInfo({ ...data });
              }}
            />
          ) : (
            <TeachersList
              teachersArray={teachersArray}
              selectedTeacher={selectedTeacher}
              setSelectedTeacher={setSelectedTeacher}
              topicToSchedule={topicToSchedule}
              closeList={() => {
                setIsSchedulingModuleOpen(false);
              }}
            />
          )
        ) : (
          <TopicsList
            courses={courses}
            openConfirmation={openConfirmation}
            appointmentsAvailable={sectionPlanSpeaking.appointmentsLeft}
            isSchedulingModuleOpen={isSchedulingModuleOpen}
          />
        )}

        {isConfirmationModalOpen && (
          <ConfirmationModal
            appointmentsAvailable={sectionPlanSpeaking.appointmentsLeft}
            onConfirm={handleConfirmScheduling}
          />
        )}
      </div>
      <SnackBarActions handleSnackbar={closeSnackBar} {...snackBarInfo} />
    </div>
  ) : (
    <UpgradePlanPage />
  );
};

export default SpeakingPage;
